import type { ReactNode } from 'react';
import { Icon, type IconName } from './icon';

interface ChipProps {
  active?: boolean;
  onClick?: () => void;
  icon?: IconName;
  children: ReactNode;
}

export function Chip({ active, onClick, icon, children }: ChipProps) {
  return (
    <button type="button" className="wb-chip" aria-pressed={!!active} onClick={onClick}>
      {icon && <Icon name={icon} size={15} />}
      {children}
    </button>
  );
}
